import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function ContactUs() {

    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const redirectToHome = () => {
        setIsSubmitted(false);
        setIsLoading(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        try {
            const formData = new FormData(event.target);
            const response = await fetch(
                'https://docs.google.com/forms/d/e/1FAIpQLSe-youPYdccsdcscx90RSBMrUox5t8Fyf2omPQXeDhsGb6j3EEw8xXy9Q/formResponse',
                {
                    method: 'POST',
                    body: formData,
                    mode: 'no-cors'
                }
            );
            console.log(response);
            setIsSubmitted(true);
        } catch (error) {
            console.error('Error submitting form:', error);
            setIsLoading(false);
        }
    };

    return (
        <div id="contact" className="bg-gradient-to-br from-[#f5f7fa] to-[#e8eaf6] px-4 pt-24 pb-10">
            <div className="mx-auto w-full max-w-2xl">
                <div className="rounded-2xl border border-gray-100 bg-white shadow-2xl">
                    {!isSubmitted ? (
                        <div className="p-6 sm:p-8">
                            <h2 className="mb-2 text-center text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#e00a7e] to-[#6c32ee]">
                                Learn With Stack 
                            </h2>
                            <p className="mb-8 text-center text-sm tracking-wide text-gray-700">
                                Reach out to us by submitting your queries
                            </p>

                            <form onSubmit={handleSubmit} className="space-y-4">
                                <div className="relative">
                                    <input
                                        type="text"
                                        placeholder="Full Name"
                                        name="entry.338508354"
                                        autoComplete="name"
                                        className="w-full rounded-lg border border-gray-300 px-4 py-3 pl-10 shadow-sm transition duration-200 ease-in-out hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#e00a7e]"
                                        required
                                    />
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                                    </svg>
                                </div>

                                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                                    <div className="relative">
                                        <input
                                            type="email"
                                            placeholder="Email Address"
                                            name="entry.1101653039"
                                            autoComplete="email"
                                            className="w-full rounded-lg border border-gray-300 px-4 py-3 pl-10 shadow-sm transition duration-200 ease-in-out hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#e00a7e]"
                                            required
                                        />
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                        </svg>
                                    </div>

                                    <div className="relative">
                                        <input
                                            type="tel"
                                            name="entry.1711163296"
                                            placeholder="Phone (Optional)"
                                            autoComplete="tel"
                                            className="w-full rounded-lg border border-gray-300 px-4 py-3 pl-10 shadow-sm transition duration-200 ease-in-out hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#e00a7e]"
                                        />
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="pointer-events-none absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498A1 1 0 0121 16.72V20a2 2 0 01-2 2h-1C9.163 22 2 14.837 2 6V5z" />
                                        </svg>
                                    </div>
                                </div>

                                <div className="relative">
                                    <textarea
                                        placeholder="Your Query"
                                        name="entry.782320017"
                                        className="w-full resize-none rounded-lg border border-gray-300 px-4 py-3 pl-10 shadow-sm transition duration-200 ease-in-out hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#e00a7e]"
                                        rows="5"
                                    />
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="pointer-events-none absolute left-3 top-4 h-5 w-5 text-gray-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                                    </svg>
                                </div>

                                <div className="space-y-3 rounded-xl border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700">
                                    <label className="flex gap-3">
                                        <input
                                            type="checkbox"
                                            name="entry.822791526"
                                            className="mt-1 h-4 w-4 rounded border-gray-300 text-[#e00a7e] focus:ring-[#e00a7e]"
                                        />
                                        <span>
                                            I agree to receive SMS messages from Learn With Stack LLC regarding account notifications and customer support. Message frequency may vary. Message and data rates may apply. Reply STOP to opt out or HELP for help.
                                        </span>
                                    </label>

                                    <label className="flex gap-3">
                                        <input
                                            type="checkbox"
                                            name="entry.607900696"
                                            className="mt-1 h-4 w-4 rounded border-gray-300 text-[#e00a7e] focus:ring-[#e00a7e]"
                                        />
                                        <span>
                                            I agree to receive marketing or promotional SMS messages from Learn With Stack LLC. Message frequency may vary. Message and data rates may apply. Reply STOP to opt out or HELP for help.
                                        </span>
                                    </label>
                                </div>

                                <p className="text-xs text-gray-600">
                                    By submitting this form, you agree to our{' '}
                                    <Link to="/terms-of-service" className="font-medium text-blue-600 hover:text-blue-800">
                                        Terms &amp; Conditions
                                    </Link>{' '}
                                    and{' '}
                                    <Link to="/privacy-policy" className="font-medium text-blue-600 hover:text-blue-800">
                                        Privacy Policy
                                    </Link>
                                    .
                                </p>

                                <button
                                    type="submit"
                                    className="w-full rounded-lg bg-gradient-to-r from-[#e00a7e] to-[#6c32ee] px-4 py-3 text-lg font-bold text-white transition-transform duration-300 hover:scale-[1.02] disabled:cursor-not-allowed disabled:opacity-70"
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Submitting...' : 'Send your message'}
                                </button>
                            </form>

                            <div className="mt-6 text-center text-xs text-gray-600">
                                Your privacy is important to us. We'll never share your information.
                            </div>
                        </div>
                    ) : (
                        <div className="p-6 text-center sm:p-8">
                            <div className="mb-6">
                                <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
                                    <svg className="h-8 w-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>
                                <h2 className="mb-2 text-2xl font-bold text-gray-900">Thank You for Reaching Out!</h2>
                                <p className="text-sm text-gray-600">
                                    We have received your request and appreciate you contacting us. Our team will get back to you shortly.
                                </p>
                            </div>
                            <button
                                onClick={redirectToHome}
                                className="rounded-full bg-gradient-to-r from-[#7b45ef] to-[#e2228c] px-6 py-2 text-white transition-colors hover:opacity-90"
                            >
                                Send another message
                            </button>
                            <div className="mt-6 text-center text-xs text-gray-600">
                                Your privacy is important to us. We'll never share your information.
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ContactUs;
